<style scoped lang="sass">
@import '../variables'

$bgImage: '../assets/bg-6.jpg'
.login-container
  display: flex
  width: 100%
  height: 100vh
  align-items: center
  .login-left, .login-right
    width: 50%
  .login-left
    .login-form-wrapper
      margin: 0 auto
      width: 70%
      max-width: 400px
    .left-logo
      height: 3.5rem
      margin-bottom: 2rem
      img
        height: 100%
  .login-right
    height: 100%
    display: flex
    align-items: center
    position: relative
    overflow: hidden
    &.login-1
      background: #{$colorMenu} url($bgImage)
      background-size: cover
      .login-right-content
        position: relative
        width: 100%
        height: 100%
        text-align: center
        background: rgba($colorMenu, 0.75)
        display: flex
        align-items: center
        width: 100%
        text-align: center
        .width-wrapper
          width: 100%
        .logo-box
          width: 60%
          max-width: 400px
          display: inline-block
          background: transparent
          padding: 3rem 2rem
          overflow: hidden
          position: relative
          border-radius: 8px
          box-shadow: 0 0 10px 2px rgba(black, 0.1)
          .inner-content
            position: relative
            &:before
              content: ''
              position: absolute
              width: 100%
              left: 0
              height: 0px
              top: 50%
              background: white
              // box-shadow: 0 0 100px 110px rgba(white, 0.9)
            img
              position: relative
              max-width: 100%
            .slogan
              position: relative
              font-size: 1.1rem
              padding-top: 0.5rem
              font-weight: 400
              color: darken($colorMenu, 15%)
          .login-right-cover
            position: absolute
            top: 0
            bottom: 0
            right: 0
            left: 0
            filter: blur(8px)
            transform: scale(1.3)
            background: #{$colorMenu} url($bgImage)
            background-size: cover
            // opacity: 0.95
            &:before
              background: rgba(white, 0.84)
              content: ''
              position: absolute
              top: 0
              bottom: 0
              right: 0
              left: 0

    &.login-2
      background: #444 url($bgImage)
      background-size: cover
      background-position: center center
      .login-right-content
        position: relative
        width: 100%
        height: 100%
        text-align: center
        width: 100%
        .width-wrapper
          position: absolute
          width: 100%
          bottom: -5px
        .logo-box
          width: 100%
          display: inline-block
          background: rgba($colorMenu, 0.93)
          padding: 2rem 2rem
          overflow: hidden
          position: relative
          box-shadow: 0 0 10px 5px rgba(black, 0.2)
          .inner-content
            position: relative
            text-align: left
            .slogan
              position: relative
              font-size: 1.2rem
              font-weight: 300
              color: rgba(white, 0.95)
</style>

<template lang="pug">
.login-container
  .login-left
    .login-form-wrapper
      .left-logo(v-if='option === 2')
        img(src='../assets/logo.png')
      login-form
  .login-right(:class="'login-' + option")
    .login-right-content(v-if='option === 1')
      .width-wrapper
        .logo-box
          .login-right-cover
          .inner-content
            img(src='../assets/logo.png')
            .slogan Catering, tailor made.
    .login-right-content(v-if='option === 2')
      .width-wrapper
        .logo-box
          .inner-content
            .left-logo(style='text-align: center')
              img(src='../assets/white-logo.png',style='max-height: 80px')

  router-view
</template>

<script>
import LoginForm from './blocks/LoginForm.vue'
export default {
  components: { LoginForm },
  data ( ) {
    return {
      option: 2,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/anonymous/Login.vue